/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { KlantinfoVoorwieDto } from '../models/klantinfo-voorwie-dto';
import { VoorwiepickerDto } from '../models/voorwiepicker-dto';

@Injectable({
  providedIn: 'root',
})
export class VoorwiepickerApiService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getVoorwies
   */
  static readonly GetVoorwiesPath = '/api/extern/voorwiepicker/get-voorwies';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getVoorwies$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVoorwies$Plain$Response(params?: {

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<StrictHttpResponse<Array<VoorwiepickerDto>>> {

    const rb = new RequestBuilder(this.rootUrl, VoorwiepickerApiService.GetVoorwiesPath, 'get');
    if (params) {
      rb.header('BaaS-Context-Frontend', params['BaaS-Context-Frontend'], {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<VoorwiepickerDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getVoorwies$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVoorwies$Plain(params?: {

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<Array<VoorwiepickerDto>> {

    return this.getVoorwies$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<VoorwiepickerDto>>) => r.body as Array<VoorwiepickerDto>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getVoorwies()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVoorwies$Response(params?: {

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<StrictHttpResponse<Array<VoorwiepickerDto>>> {

    const rb = new RequestBuilder(this.rootUrl, VoorwiepickerApiService.GetVoorwiesPath, 'get');
    if (params) {
      rb.header('BaaS-Context-Frontend', params['BaaS-Context-Frontend'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<VoorwiepickerDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getVoorwies$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVoorwies(params?: {

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<Array<VoorwiepickerDto>> {

    return this.getVoorwies$Response(params).pipe(
      map((r: StrictHttpResponse<Array<VoorwiepickerDto>>) => r.body as Array<VoorwiepickerDto>)
    );
  }

  /**
   * Path part for operation getVoorwiesFilteredByAction
   */
  static readonly GetVoorwiesFilteredByActionPath = '/api/extern/voorwiepicker/get-voorwies-filter-action';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getVoorwiesFilteredByAction$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVoorwiesFilteredByAction$Plain$Response(params?: {
    actie?: string;

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<StrictHttpResponse<Array<VoorwiepickerDto>>> {

    const rb = new RequestBuilder(this.rootUrl, VoorwiepickerApiService.GetVoorwiesFilteredByActionPath, 'get');
    if (params) {
      rb.query('actie', params.actie, {});
      rb.header('BaaS-Context-Frontend', params['BaaS-Context-Frontend'], {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<VoorwiepickerDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getVoorwiesFilteredByAction$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVoorwiesFilteredByAction$Plain(params?: {
    actie?: string;

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<Array<VoorwiepickerDto>> {

    return this.getVoorwiesFilteredByAction$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<VoorwiepickerDto>>) => r.body as Array<VoorwiepickerDto>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getVoorwiesFilteredByAction()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVoorwiesFilteredByAction$Response(params?: {
    actie?: string;

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<StrictHttpResponse<Array<VoorwiepickerDto>>> {

    const rb = new RequestBuilder(this.rootUrl, VoorwiepickerApiService.GetVoorwiesFilteredByActionPath, 'get');
    if (params) {
      rb.query('actie', params.actie, {});
      rb.header('BaaS-Context-Frontend', params['BaaS-Context-Frontend'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<VoorwiepickerDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getVoorwiesFilteredByAction$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVoorwiesFilteredByAction(params?: {
    actie?: string;

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<Array<VoorwiepickerDto>> {

    return this.getVoorwiesFilteredByAction$Response(params).pipe(
      map((r: StrictHttpResponse<Array<VoorwiepickerDto>>) => r.body as Array<VoorwiepickerDto>)
    );
  }

  /**
   * Path part for operation getAantalVoorwies
   */
  static readonly GetAantalVoorwiesPath = '/api/extern/voorwiepicker/get-aantal-voorwies';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAantalVoorwies$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAantalVoorwies$Plain$Response(params?: {

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, VoorwiepickerApiService.GetAantalVoorwiesPath, 'get');
    if (params) {
      rb.header('BaaS-Context-Frontend', params['BaaS-Context-Frontend'], {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAantalVoorwies$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAantalVoorwies$Plain(params?: {

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<number> {

    return this.getAantalVoorwies$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAantalVoorwies()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAantalVoorwies$Response(params?: {

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, VoorwiepickerApiService.GetAantalVoorwiesPath, 'get');
    if (params) {
      rb.header('BaaS-Context-Frontend', params['BaaS-Context-Frontend'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAantalVoorwies$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAantalVoorwies(params?: {

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<number> {

    return this.getAantalVoorwies$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation getKlantinfoVoorwie
   */
  static readonly GetKlantinfoVoorwiePath = '/api/extern/voorwiepicker/get-klantinfo-voorwie';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getKlantinfoVoorwie$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getKlantinfoVoorwie$Plain$Response(params?: {

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<StrictHttpResponse<KlantinfoVoorwieDto>> {

    const rb = new RequestBuilder(this.rootUrl, VoorwiepickerApiService.GetKlantinfoVoorwiePath, 'get');
    if (params) {
      rb.header('BaaS-Context-Frontend', params['BaaS-Context-Frontend'], {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<KlantinfoVoorwieDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getKlantinfoVoorwie$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getKlantinfoVoorwie$Plain(params?: {

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<KlantinfoVoorwieDto> {

    return this.getKlantinfoVoorwie$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<KlantinfoVoorwieDto>) => r.body as KlantinfoVoorwieDto)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getKlantinfoVoorwie()` instead.
   *
   * This method doesn't expect any request body.
   */
  getKlantinfoVoorwie$Response(params?: {

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<StrictHttpResponse<KlantinfoVoorwieDto>> {

    const rb = new RequestBuilder(this.rootUrl, VoorwiepickerApiService.GetKlantinfoVoorwiePath, 'get');
    if (params) {
      rb.header('BaaS-Context-Frontend', params['BaaS-Context-Frontend'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<KlantinfoVoorwieDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getKlantinfoVoorwie$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getKlantinfoVoorwie(params?: {

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<KlantinfoVoorwieDto> {

    return this.getKlantinfoVoorwie$Response(params).pipe(
      map((r: StrictHttpResponse<KlantinfoVoorwieDto>) => r.body as KlantinfoVoorwieDto)
    );
  }

}
